import { Config, makeRequest } from "@paywithglide/glide-js";
import { logger } from "../logger";

export type OnrampKycStatusRequest = {
  customerId: string;
};

export type OnrampKycStatusResponse = {
  status: number;
  code: number;
  data: {
    status: string; // "COMPLETED", "PENDING", etc.
    countryISO: string;
    currentKycVerificationStep: string;
    previousSuccessfulKycStep: string;
  };
};

export async function checkKycStatus(
  glideConfig: Config,
  request: OnrampKycStatusRequest,
): Promise<OnrampKycStatusResponse> {
  try {
    const response = await makeRequest<OnrampKycStatusResponse>(glideConfig, {
      url: `/onramp/kyc/status`,
      method: "POST",
      body: request,
    });

    if (response.status !== 1 || response.code !== 200) {
      throw new Error(
        `Onramp KYC status API error: status ${response.status}, code ${response.code}`,
      );
    }

    return response;
  } catch (error) {
    logger.error(`Failed to check Onramp KYC status: ${error}`);
    throw error;
  }
}
